<nav
  class="fixed-top navbar-light bg-white px-3 max-[400px]:px-1 d-flex justify-content-between navbar"
>
  <span class="navbar-brand mb-0 h1 flex">
    <button class="btn" (click)="collapseClick($event)">
      <img src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/element-3.svg" />
    </button>
    <img class="lg:ms-3 ms-0 img-logo max-[450px]:hidden" height="30px" src="assets/logo.svg" alt="" />
  </span>
  <div class="flex flex-1 justify-end items-center lg:gap-4 gap-2 max-[400px]:gap-1">
    <div *ngIf="detailProfile" class="flex flex-col justify-end w-auto items-end">
      <span class="lg:text-[16px] text-[12px] font-semibold text-end max-[400px]:text-start truncate block max-[400px]:w-[100px]">Hallo {{ detailProfile.name || 'User' }}</span>
      <div class="d-flex justify-content-end align-items-center gap-2">
        <a routerLink="/subscriptions" class="p-0">
          <img [src]="getPackageIcon()" alt="package icon" class="package-icon" style="height: 19px; width: auto;" />
        </a>
        <span *ngIf="!profileMode" class="mode-on-sandbox text-nowrap text-[12px] max-[400px]:text-[10px]">Sandbox Mode</span>
        <span *ngIf="profileMode" class="mode-on-live text-nowrap text-[12px] max-[400px]:text-[10px]">Live Mode</span>
      </div>
    </div>
    <div ngbDropdown display="dynamic" id="profile-dropdown-container" autoClose="inside">
      <div class="w-[35px] h-[35px]">
        <img
          *ngIf="detailProfile"
          [src]="
            detailProfile.photo_profile_url
              ? detailProfile.photo_profile_url
              : 'https://cdn.pixabay.com/photo/2014/04/03/10/32/businessman-310819_960_720.png'
          "
          class="main-profile-img rounded-circle"
          style="width: 35px; cursor: pointer; height: 35px"
          alt="Avatar"
          id="dropdownBasic1"
          ngbDropdownToggle
        />
      </div>
      <div
        ngbDropdownMenu
        aria-labelledby="dropdownBasic1"
        class="dropdown-menu dropdown-menu-end drop-profile shadow-lg"
        style="width: 300px"
      >
        <div class="py-2 px-4" id="profile-dropdown-content">
          <div>
            <span class="profile">Profile</span>
            <hr />
            <div class="d-flex align-items-center gap-3">
              <div class="d-flex flex-column col-4">
                <small
                  class="px-1"
                  [ngClass]="profileMode ? 'mode-non' : 'mode-on-sandbox'"
                  >Mode</small
                >
                <span
                  class=""
                  [ngClass]="profileMode ? 'sandbox-off' : 'sandbox-on'"
                  >Sandbox</span
                >
              </div>
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="switchMode"
                  [checked]="profileMode"
                  [(ngModel)]="profileMode"
                  style="width: 50px; height: 30px"
                  (change)="toggleEnvironment()"
                />
              </div>
              <div class="d-flex flex-column col-4">
                <small
                  class="px-1"
                  [ngClass]="profileMode ? 'mode-on-live' : 'mode-non'"
                  >Mode</small
                >
                <span class="" [ngClass]="profileMode ? 'live-on' : 'live-off'"
                  >Live</span
                >
              </div>
            </div>
            <hr />
          </div>
          <button (click)="logout()" ngbDropdownItem class="p-0">
            <div class="flex align-items-center gap-2">
              <img
                src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/logout.svg"
                alt=""
                width="28px"
              />
              <span class="mx-3 text-primary">Logout</span>
            </div>
          </button>
        </div>
      </div>
    </div>
    <button class="btn p-0" (click)="openNotifDrawer()">
      <nz-badge [nzCount]="totalNotif" [nzOverflowCount]="99">
      <img class="d-flex" src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/notification.svg" />
      </nz-badge>
    </button>
  </div>
</nav>

<app-notif-drawer [isVisibleNotif]="isNotifDrawerOpen" (isVisibleNotifEvent)="closeNotifDrawer()" (totalNotifChange)="onTotalNotifChanged($event)"/>
<app-modal-alert-add-phone [isVisibleAlert]="openModalAlertNumber"></app-modal-alert-add-phone>
<app-modal-alert-switch [isVisibleSwitch]="openModalAlertSwitch" (isVisibleSwitchEvent)="closeSwitchMode()"/>
<app-modal-banner-notif [isVisibleBanner]="true" />
